import actionTypes from './actionTypes';

const INITIAL_STATE = {
  getCafesContractLoading: false,
  getCafesContractFailed: false,
  getCafesContractError: false,
  getCafesContractMessage: null,
  cafesContract: [],
  cafeContract: {
    totalRecords: 0,
  },

  addOrEditCafeContractLoading: false,
  addOrEditCafeContractFailed: false,
  addOrEditCafeContractError: false,
  addOrEditCafeContractMessage: false,
  addOrEditCafeContractFailedMessagesList: [],

  getCitiesContractLoading: false,
  getCitiesContractFailed: false,
  getCitiesContractError: false,
  getCitiesContractMessage: null,
  cities: [],

  getCafeContractByIdLoading: false,
  getCafeContractByIdFailed: false,
  getCafeContractByIdError: false,
  getCafeContractByIdMessage: '',
  fetchedCafeContractById: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_CAFE_CONTRACT_LOADING: {
      return {
        ...state,
        getCafesContractLoading: true,
        getCafesContractFailed: false,
        getCafesContractError: false,
        getCafesContractMessage: null,
        cafesContract: [],
      };
    }
    case actionTypes.GET_CAFE_CONTRACT_SUCCESS: {
      return {
        ...state,
        getCafesContractLoading: false,
        getCafesContractFailed: false,
        getCafesContractError: false,
        getCafesContractMessage: null,
        cafeContract: {
          ...action.payload,
        },
        cafesContract: [...action.payload.cafeContracts],
      };
    }
    case actionTypes.GET_CAFE_CONTRACT_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getCafesContractLoading: false,
        getCafesContractFailed: true,
        getCafesContractError: false,
        getCafesContractMessage: message,
      };
    }
    case actionTypes.GET_CAFE_CONTRACT_REJECT: {
      return {
        ...state,
        getCafesContractLoading: false,
        getCafesContractFailed: false,
        getCafesContractError: true,
        getCafesContractMessage: null,
      };
    }

    case actionTypes.INSERT_NEW_CAFE_CONTRACT_LOADING: {
      return {
        ...state,
        addOrEditCafeContractLoading: true,
        addOrEditCafeContractFailed: false,
        addOrEditCafeContractError: false,
        addOrEditCafeContractMessage: '',
        addOrEditCafeContractFailedMessagesList: [],
      };
    }
    case actionTypes.INSERT_NEW_CAFE_CONTRACT_FAILED: {
      const { message, errors } = action.payload;
      return {
        ...state,
        addOrEditCafeContractLoading: false,
        addOrEditCafeContractFailed: true,
        addOrEditCafeContractError: false,
        addOrEditCafeContractMessage: message,
        addOrEditCafeContractFailedMessagesList: errors || [],
      };
    }
    case actionTypes.INSERT_NEW_CAFE_CONTRACT_REJECT: {
      return {
        ...state,
        addOrEditCafeContractLoading: false,
        addOrEditCafeContractFailed: false,
        addOrEditCafeContractError: true,
        addOrEditCafeContractFailedMessagesList: [],
      };
    }
    case actionTypes.INSERT_NEW_CAFE_CONTRACT_SUCCESS: {
      return {
        ...state,
        addOrEditCafeContractLoading: false,
        addOrEditCafeContractFailed: false,
        addOrEditCafeContractError: false,
        addOrEditCafeContractFailedMessagesList: [],
      };
    }

    case actionTypes.UPDATE_CAFE_CONTRACT_LOADING: {
      return {
        ...state,
        addOrEditCafeContractLoading: true,
        addOrEditCafeContractFailed: false,
        addOrEditCafeContractError: false,
        addOrEditCafeContractMessage: '',
        addOrEditCafeContractFailedMessagesList: [],
      };
    }
    case actionTypes.UPDATE_CAFE_CONTRACT_FAILED: {
      const { message, errors } = action.payload;
      return {
        ...state,
        addOrEditCafeContractLoading: false,
        addOrEditCafeContractFailed: true,
        addOrEditCafeContractError: false,
        addOrEditCafeContractMessage: message,
        addOrEditCafeContractFailedMessagesList: errors || [],
      };
    }
    case actionTypes.UPDATE_CAFE_CONTRACT_REJECT: {
      return {
        ...state,
        addOrEditCafeContractLoading: false,
        addOrEditCafeContractFailed: false,
        addOrEditCafeContractError: true,
        addOrEditCafeContractFailedMessagesList: [],
      };
    }
    case actionTypes.UPDATE_CAFE_CONTRACT_SUCCESS: {
      return {
        ...state,
        addOrEditCafeContractLoading: false,
        addOrEditCafeContractFailed: false,
        addOrEditCafeContractError: false,
        addOrEditCafeContractFailedMessagesList: [],
      };
    }

    case actionTypes.CLEAR_ADD_OR_EDIT_CAFE_CONTRACT_FORM: {
      return {
        ...state,
        addOrEditCafeContractLoading: false,
        addOrEditCafeContractFailed: false,
        addOrEditCafeContractError: false,
        addOrEditCafeContractMessage: '',
        addOrEditCafeContractFailedMessagesList: [],
      };
    }

    case actionTypes.GET_CITIES_CONTRACT_LOADING: {
      return {
        ...state,
        getCitiesContractLoading: true,
        getCitiesContractFailed: false,
        getCitiesContractError: false,
        getCitiesContractMessage: null,
        cities: [],
      };
    }
    case actionTypes.GET_CITY_CONTRACT_SUCCESS: {
      return {
        ...state,
        getCityContractLoading: false,
        cityData: action.payload,
      };
    }
    case actionTypes.GET_CITY_CONTRACT_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getCityContractLoading: false,
        getCityContractFailed: true,
        getCityContractMessage: message,
      };
    }
    case actionTypes.GET_CITY_CONTRACT_REJECT: {
      return {
        ...state,
        getCityContractLoading: false,
        getCityContractError: true,
      };
    }
    case actionTypes.GET_CITY_CONTRACT_LOADING: {
      return {
        ...state,
        getCityContractLoading: true,
        getCityContractFailed: false,
        getCityContractError: false,
        getCityContractMessage: null,
        cityData:{}
      };
    }
    case actionTypes.GET_CITIES_CONTRACT_SUCCESS: {
      return {
        ...state,
        getCitiesContractLoading: false,
        cities: action.payload.cities,
      };
    }
    case actionTypes.GET_CITIES_CONTRACT_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getCitiesContractLoading: false,
        getCitiesContractFailed: true,
        getCitiesContractMessage: message,
        cities: [],
      };
    }
    case actionTypes.GET_CITIES_CONTRACT_REJECT: {
      return {
        ...state,
        getCitiesContractLoading: false,
        getCitiesContractError: true,
        cities: [],
      };
    }

    case actionTypes.GET_CONTRACT_BY_ID_LOADING: {
      return {
        ...state,
        getCafeContractByIdLoading: true,
        getCafeContractByIdFailed: false,
        getCafeContractByIdError: false,
        fetchedCafeContractById: null,
      };
    }
    case actionTypes.GET_CONTRACT_BY_ID_FAILURE: {
      const { message } = action.payload;
      return {
        ...state,
        getCafeContractByIdLoading: false,
        getCafeContractByIdFailed: true,
        getCafeContractByIdError: false,
        getCafeContractByIdMessage: message,
        fetchedCafeContractById: null,
      };
    }
    case actionTypes.GET_CONTRACT_BY_ID_REJECT: {
      return {
        ...state,
        getCafeContractByIdLoading: false,
        getCafeContractByIdFailed: false,
        getCafeContractByIdError: true,
        getCafeContractByIdMessage: '',
        fetchedCafeContractById: null,
      };
    }
    case actionTypes.GET_CONTRACT_BY_ID_SUCCESS: {
      return {
        ...state,
        getCafeContractByIdLoading: false,
        getCafeContractByIdFailed: false,
        getCafeContractByIdError: false,
        getCafeContractByIdMessage: '',
        fetchedCafeContractById: {
          ...action.payload,
          workingHours:
            action.payload.workingHours &&
            action.payload.workingHours.length &&
            action.payload.workingHours.map(x => ({
              ...x,
              fromTime: x.fromTime.substring(0, 5),
              toTime: x.toTime.substring(0, 5),
            })),
        },
      };
    }

    default:
      return state;
  }
};
